import { apiDomain } from "../environmentVariables";
import { updateUserSession } from "../store/actions/userActions";

const refreshToken = async (refreshTokenProps) => {
    const { dispatch, user } = refreshTokenProps || {};
    try {
        if (!dispatch || !user) {
            return;
        }

        if (!user?.session) {
            return;
        }

        const queriesBody = {
            query: `query($u:String!){refresh_token(token:$u)}`,
            variables: {
                u: user.session,
                userJwtToken: user.session,
            },
        };
        const response = await fetch(apiDomain + "/graphql", {
            method: "POST",
            credentials: apiDomain ? "include" : "same-origin",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(queriesBody),
        });
        const { data } = await response.json();
        const { refresh_token } = data;

        refresh_token && dispatch(updateUserSession(refresh_token));
        return refresh_token;
    } catch (error) {
        //TODO: fix catch error when api are down?
        return null;
    }
};

export function fetchApi(url = "/graphql", body, config = {}, refreshTokenProps) {
    return refreshToken(refreshTokenProps).then((updatedJwtToken) => {
        const userJwtToken = updatedJwtToken ? updatedJwtToken : refreshTokenProps?.user?.session;

        if (body?.variables) {
            body.variables = { ...body.variables, userJwtToken: userJwtToken };
        } else {
            body.variables = { userJwtToken: userJwtToken };
        }

        return fetch(apiDomain + url, {
            method: "POST",
            credentials: apiDomain ? "include" : "same-origin",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            ...config,
            body: JSON.stringify(body),
        });
    });
}
